import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type PencilIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function PencilIcon({
  className,
  pathClassName = "stroke-teachLoop-textPrimary",
  ...props
}: PencilIconProps) {
  return (
    <Svg width={16} height={16} viewBox="0 0 16 16" {...props} fill="none">
      <Path
        d="M1.852 13.188l.404-2.774a.843.843 0 01.237-.48l7.841-7.85a.843.843 0 01.793-.229c.72.2 1.372.59 1.889 1.13a4.14 4.14 0 011.121 1.898.844.844 0 01-.228.792l-7.85 7.842a.843.843 0 01-.48.236l-2.774.405a.844.844 0 01-.953-.97zM8.85 3.576l3.575 3.575"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default PencilIcon;
